import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const t = o((i, e) => /* @__PURE__ */ l.jsx(
  r,
  {
    ref: e,
    ...i,
    image: (s) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...s,
        children: [
          /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_3410_69090)", children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5.318 8.466C5.914 9.41 6.904 10 8 10s2.086-.59 2.681-1.534l1.692 1.068C11.446 11.002 9.845 12 8 12s-3.446-.998-4.373-2.466z",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3410_69090", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
t.displayName = "SmileIcon";
export {
  t as SmileIcon,
  t as default
};
//# sourceMappingURL=index.js.map
